<div class="myre-header__menu">
  <ng-content />
</div>
